<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'账号名称 / 账号注册手机',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetPlatForm();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetPlatForm()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增账号'}" @finish="AddShop()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-platshop-obj">
        <el-table :data="shoplist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="expand">
                <template #default="scope">
                    <el-table :data="scope.row.othershop" stripe="true" empty-text="" class="TTL-table-child">
                        <template v-slot:empty><el-empty description="暂无数据" /></template>
                        <el-table-column label="id" prop="id" align="center" width="60" />
                        <el-table-column label="商户分号信息" align="left" min-width="320">
                            <template #default="scope">
                                <div class="TTL-pet-shopinfo">
                                    <div class="TTL-pet-image">
                                    <wcimage :value="scope.row.logo" :option="{size:'middle'}" />
                                    <div class="TTL-isadmin" v-if="scope.row.is_platform"></div>
                                    </div>
                                    <div class="TTL-pet-shoptitle">
                                    <span class="TTL-shopname">{{scope.row.shopname}}<i>（{{scope.row.levelname}}）</i></span>
                                    <span class="TTL-level">{{scope.row.phone}}</span>
                                    <span class="TTL-level" style="zoom:.9;letter-spacing:1px">{{'注册时间：'+scope.row.inputtime}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="商户统计" align="center" min-width="340">
                            <template #default="scope">
                                <div class="TTL-shop-stat">
                                    <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.pets}}</span><span class="stat-title">宠物数量</span></div></div>
                                    <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.petfollows}}</span><span class="stat-title">宠物记录</span></div></div>
                                    <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.births}}</span><span class="stat-title">繁育数量</span></div></div>
                                    <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.members}}</span><span class="stat-title">会员数量</span></div></div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="跟进 / 登录记录" align="left" min-width="350">
                            <template #default="scope">
                                <div class="TTL-time" v-if="scope.row.follow.typename && scope.row.follow.typename!=''">
                                    <el-tooltip
                                    class="box-item"
                                    effect="dark"
                                    :content="scope.row.follow.description ? scope.row.follow.description : ''"
                                    placement="top">
                                    <span class="followdesc" />
                                    </el-tooltip>
                                    <span class="followmsg"><i>【{{scope.row.follow.typename}}】</i>{{scope.row.follow.followtime}}</span>
                                </div>
                                <div class="TTL-time" v-if="scope.row.last_login_name!=''">【最后登录】{{scope.row.last_login_name}}（{{scope.row.last_visit_time}}）</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" fixed="right" min-width="280">
                            <template #default="scope">
                                <div class="TTL-button">
                                <el-button @click="ShopFollow(scope.row.id,scope.row.shopname,scope.row.logo,scope.row.levelname)">跟进</el-button>
                                <el-button @click="EditShop(scope.row.id)">编辑</el-button>
                                <el-button type="del" @click="DelShop(scope.row.id)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <!-- <el-table-column type="selection" /> -->
            <el-table-column label="id" prop="id" align="center" width="60" />
            <el-table-column label="商户信息" align="left" min-width="320">
                <template #default="scope">
                    <div class="TTL-pet-shopinfo">
                        <div class="TTL-pet-image">
                            <wcimage :value="scope.row.logo" :option="{size:'middle'}" />
                            <div class="TTL-isadmin" v-if="scope.row.is_platform"></div>
                            </div>
                            <div class="TTL-pet-shoptitle">
                            <span class="TTL-shopname">{{scope.row.shopname}}<i>（{{scope.row.levelname}}）</i></span>
                            <span class="TTL-level">{{scope.row.phone}}</span>
                            <span class="TTL-level" style="zoom:.9;letter-spacing:1px">{{'注册时间：'+scope.row.inputtime}}</span>
                            </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="商户统计" align="center" min-width="300">
                <template #default="scope">
                    <div class="TTL-shop-stat">
                        <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.pets}}</span><span class="stat-title">宠物数量</span></div></div>
                        <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.petfollows}}</span><span class="stat-title">宠物记录</span></div></div>
                        <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.births}}</span><span class="stat-title">繁育数量</span></div></div>
                        <div class="TTL-shop-stat-info"><div class="TTL-shop-stat-info-in"><span class="stat-nums">{{scope.row.stat.members}}</span><span class="stat-title">会员数量</span></div></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="跟进 / 登录记录" align="center" min-width="300">
                <template #default="scope">
                    <div class="TTL-time" v-if="scope.row.follow.typename && scope.row.follow.typename!=''">
                        <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="scope.row.follow.description ? scope.row.follow.description : ''"
                        placement="top">
                        <span class="followdesc" />
                        </el-tooltip>
                        <span class="followmsg"><i>【{{scope.row.follow.typename}}】</i>{{scope.row.follow.followtime}}</span>
                    </div>
                    <!-- <div class="TTL-time" v-if="scope.row.last_login_name!=''">【最后登录】{{scope.row.last_login_name}}（{{scope.row.last_visit_time}}）</div> -->
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="180">
                <template #default="scope">
                    <div class="TTL-button">
                    <el-button @click="ShopFollow(scope.row.id,scope.row.shopname,scope.row.logo,scope.row.levelname)">跟进</el-button>
                    <el-button @click="EditShop(scope.row.id)">编辑</el-button>
                    <!-- <el-button type="del" @click="DelShop(scope.row.id)">删除</el-button> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <!-- <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div> -->
            <div class="TTL-page TTL-page-right">
                <el-pagination
                    @current-change="changepage"
                    @size-change="changesize"
                    v-model:current-page="param.p"
                    v-model:page-size="param.rollpage"
                    :page-sizes="[20,40,60,100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="param.rows"
                />
            </div>
        </div>
    </div>


</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
export default {
    components:{},
    data() {
        return {
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            shoplist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetPlatForm();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetPlatForm();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetPlatForm();
            }else {
                this.GetPlatForm();
            }
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的账号',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelShopsMore(ids);
                }else if(index==2) {
                    this.EditShopMore(ids);
                }
               
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息 **/
        DelShop(id) {
            this.$confirm.confirm(
                '您是否确定要删除当前账号 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.DelShopsMore(id);
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息操作 **/
        DelShopsMore(ids) {
            INTERFACE_MODEL_SHOP.DEL_SHOPS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetPlatForm();
            });
        },


        /** 编辑账号信息 **/
        EditShop(id) {
            this.EditShopMore(id);
        },

        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        /** 获取平台账号inxi **/
        GetPlatForm() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-platshop-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.GET_PLATFORM_SHOP(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.shoplist=res.data.list;
            });
        },


        /** 修改当前页数 **/
        changepage(p) {
            this.param.p=p;
            this.GetPlatForm();
        },


        changesize(rollpage) {
            this.param.rollpage=rollpage;
            this.GetPlatForm();
        },


        /** 新增管理员信息 **/
        AddShop() {
            var navinfo={name:'新增账号',labelentry:'AddPlatFormShop',components:'AddPlatFormShop',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑管理员信息 **/
        EditShopMore(ids) {
            var navinfo={name:'编辑账号',labelentry:'EditPlatFormShop',components:'EditPlatFormShop',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 跳转至跟进记录 **/
        ShopFollow(id,shopname,logo,levelname) {
            var navinfo={name:'商户跟进记录',labelentry:'ShopFollow',components:'ShopFollow',isshow:false};
            var data={Method:'',id:id,shopname:shopname,logo:logo,levelname:levelname};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.shoplist.length;i++) this.shoplist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.shoplist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.shoplist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-shopinfo {display:inline-flex;align-items: center;width:100%}
.TTL-pet-image {position: relative;display: inline-block;width:70px;height: 70px;}
.TTL-pet-shoptitle {width:calc(100% - 60px - 20px);margin-left:20px;text-align: left;font-size:0;}
.TTL-shopname {display:inline-block;width:100%;font-size:12px;font-weight: 550;letter-spacing: .5px;line-height: 13px;float:left;}
.TTL-shopname i {font-style: normal;zoom: .9;font-weight: 500;letter-spacing: 0;color:#777777;letter-spacing: 2px;}
.TTL-level {display:inline-block;width:100%;font-size:12px;color:#777777;line-height: 13px;float:left;margin-top:10px;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 6px;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:22px;
    height:22px;
    border-radius: 50%;
    background-color: #666eeb;
    background-image:url(@/assets/icon/goventmennt.png);
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: center;
}
.TTL-time {
    width:100%;
    font-size:12px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.followdesc {
    width:17px;
    height: 17px;
    border-radius: 50%;
    background-image:url(@/assets/icon/warning-blue.png);
    background-repeat: no-repeat;
    background-size:100%;
    background-position: center;
}
.TTL-table-child {
    display:inline-block;
    padding:0 0 0 50px;
    width:calc(100% - 50px);
}
.followmsg {display:inline-block;text-align:center;}
.followmsg i {font-style:normal;font-weight: 500;}
.TTL-shop-stat-info {width:65px;height: 65px;padding:0 5px;text-align: center;display:inline-flex;justify-content: center;align-items: center;}
.TTL-shop-stat-info-in {display: inline-block;width:100%;}
.stat-nums {display:inline-block;width:100%;text-align: center;font-size:14px;font-weight: 550;}
.stat-title {display:inline-block;width:100%;text-align: center;font-size:14px;letter-spacing: 1px;zoom:.8;}
</style>